<kendo-grid #contactsGrid
            [data]="gridData"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [sort]="gridState.sort"
            [filter]="gridState.filter"
            [sortable]="true"
            [pageable]="true"
            [filterable]="true"
            [resizable]="true"
            (dataStateChange)="dataStateChange($event)">
    <kendo-grid-column field="contactName" title="Name" width="100"></kendo-grid-column>
    <kendo-grid-column field="contactTitle" title="Title" width="100"></kendo-grid-column>
    <kendo-grid-column field="isDefault" title="Default" width="50">
        <ng-template kendoGridCellTemplate let-dataItem>
            <input type="checkbox" [checked]="dataItem.isDefault" disabled />
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="phone" title="Phone" width="100">
        <ng-template kendoGridCellTemplate let-dataItem>
            <a href="tel:{{dataItem.phone}}">{{dataItem.phone | phone}}{{dataItem.phoneExt != '' ? 'x' + dataItem.phoneExt : ''}}</a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="cell" title="Mobile" width="100">
        <ng-template kendoGridCellTemplate let-dataItem>
            <a href="tel:{{dataItem.cell}}">{{dataItem.cell | phone}}</a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="email" title="Email" width="100">
        <ng-template kendoGridCellTemplate let-dataItem>
            <a href="mailto:{{dataItem.email}}">{{dataItem.email}}</a>
        </ng-template>
    </kendo-grid-column>
</kendo-grid>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':isLoading}" *ngIf="isLoading">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
